import React, {PureComponent} from 'react'
import cn from "classnames"
import injectSheet from 'react-jss'
import theme from "../../styles/theme"
import SocialLinks from "./SocialLinks"

class AuthorAndShareLinks extends PureComponent {

    render() {
        const {classes, className, article, showShareIcons=true} = this.props;

        return <div className={cn(classes.container, className)}>
            {showShareIcons &&
            <div className={classes.column} data-cy="shareButtonContainer">
                <SocialLinks size="small" showLinkedIn={article.linkedin_share} />
            </div>
            }
        </div>
    }
}

export default injectSheet(
    {
        container: {
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: 'center',
            [theme.breakpoint("tablet")]: {
                justifyContent: 'left'
            }
        },
        column: {
            display: "flex",
            flexDirection: "column",
            color: theme.colors.assent,
            fontSize: theme.font.info.fontSize,
            fontWeight: theme.font.info.fontWeight,
            lineHeight: theme.font.info.lineHeight
        },
        titleContainer: {
            flexGrow: 1,
            lineHeight: "1.2rem",
            [theme.breakpoint("tablet")]: {
                flexGrow: 0,
                minWidth: 170
            },
        },
        title: {
            fontWeight: "normal",
            color: theme.colors.black,
        },
        image: {
            width: 56,
            height: 56,
            borderRadius: "50%",
            '&.small': {
                width: 42,
                height: 42,
            }
        },
        shareLink: {
            marginRight: theme.spacing.small,
            textDecoration: "none",
            transition: "color 0.3s",
            color: theme.colors.assent,
            "&:hover": {
                color: theme.colors.primary,
            }
        },
        shareIcon: {
            height: 32,
            width: 32,
            [theme.breakpoint("tablet")]: {
                height: 24,
                width: 24,
            },
        }
    }
)(AuthorAndShareLinks)





// WEBPACK FOOTER //
// ./src/components/Article/AuthorAndShareLinks.js